import { locationIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const bulkAddProductLocations = {
  name: "bulkAddProductLocations" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    locationIds: z.array(locationIdFormat.schema),
  }),
  output: z.object({
    addedCount: z.number().int(),
    alreadyExistedCount: z.number().int(),
  }),
};
